export default {
  EFeatures: {
    CHANGE_PROPERTIES: 1,
    APPROVE_DOCUMENT_IN_FLOW: 2,
    CANCEL_CHECKOUT: 4,
    CANCEL_FLOW: 5,
    CHECKOUT_CHECKIN: 6,
    SEND_DOCUMENT: 11,
    SEND_BY_EMAIL: 12,
    BECOME_OBSOLETE: 13,
    //PRINT : 14,
    NOTIFY_USERS: 15,
    DOWNLOAD: 16,
    DOWNLOAD_OLD_REVISIONS: 17,
    SHARE_DOCUMENT: 18,
    DELETE_DOCUMENT: 20,
    REVERT_REVISION: 21,
    REVIEW_DOCUMENT_IN_FLOW: 22,
    REPLACE_FILE: 23,
    VIEW_DOCUMENT: 24,
    VIEW_OLD_REVISIONS: 25,
    PRINT: 26,
    DIGITAL_SIGNATURE: 27,
    LINK_FILE: 28,
    CanD4Sign: 29,
    CanCertificata: 30,
    DOCUMENT_AUDIT: 31,
    CONVERT_PDF: 32
  },
};
